import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import Corehubsubtab from "./corehubsubtab";
import { getLearnerCourses } from "../../../Redux/CourseDetails";

function Corehubtab({ hubName, hubDesc }) {
	const dispatch = useDispatch();
	const { instance } = useMsal();
	const activeAccount = instance.getActiveAccount();
	const enterpriseId = activeAccount.idTokenClaims?.enterpriseID;
	const userLevel = activeAccount.idTokenClaims?.jobFamilyDescription;

	const { coursesByHub } = useSelector((state) => state.courseDetails);
	const userData = useSelector((state) => state.userDetails.userData[0]);

	useEffect(() => {
		dispatch(getLearnerCourses(enterpriseId));
	}, [enterpriseId, dispatch]);

	let progressValue = 0;
	let completedCourses = 0;
	let fullCourses = 0;

	coursesByHub?.forEach((hub) => {
		if (hub?.hubName !== hubName) return;

		const eligibleCourses =
			hub.courses || [];

		fullCourses = eligibleCourses.length;

		completedCourses = eligibleCourses.filter(
			c => Boolean(c.completionDate)
		).length;

		progressValue =
			fullCourses > 0
				? Math.round((completedCourses / fullCourses) * 100)
				: 0;
	});

	const isGenAIHub = hubName === "GenAI and Agentic AI Hub";

	return (
		<>
			<div className="core-hub-section">
				<div className="core-hub-wrap">
					<div className="core-hub-row row1">
						<div className="core-hub-box">
							{isGenAIHub ? (<video
								className="genai-video"
								autoPlay
								muted
								loop
								playsInline
								style={{
									width: "100%",
									height: "70%",
									objectFit: "cover",
									borderRadius: "12px",
									boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
								}}
							>
								<source
									src={process.env.PUBLIC_URL + "/Assets/LearningHubs/GenAIIntro.mp4"}
									type="video/mp4"
								/>
								Your browser does not support the video tag.
							</video>) : (
								<>
									<img
										src={
											process.env.PUBLIC_URL + "/Assets/Home/about-thumbnail.png"
										}
										alt="about-thumbnail"
										className="about-thumbnail"
									/>
									<img
										src={process.env.PUBLIC_URL + "/Assets/Home/Play-Visual.png"}
										alt="play"
										className="Play-Visual"
									/>
								</>
							)}
						</div>
					</div>

					<div className="core-hub-row row2">
						<div className="core-hub-box">
							<h2 className="section-headings">{hubName === "Foundation" ? "Core Hub" : hubName}</h2>
							<h3>
								<span>
									{completedCourses}/{fullCourses}{" "}
								</span>
								Courses completed{" "}
							</h3>
							{Object.entries(hubDesc).map(([key, value]) => (
								<p key={key}>{value}</p>
							))}
						</div>

						<div className="progress-bar-box">
							<div className="progress-container">
								<div className="progress-header">
									<span className="progress-label">Overall Progress</span>
									<span className="progress-value">{progressValue}%</span>
								</div>

								<div className="progress-track">
									<div
										className="progress-fill"
										style={{ width: `${progressValue}%` }}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="corehub-subtab-section">
				<Corehubsubtab hubName={hubName} />
			</div>
		</>
	);
}

export default Corehubtab;
